/**
 * package: com.inq.flash.client.chatskins
 * class: BalloonNotifier
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.BalloonNotifier = function() {
};
$hxClasses['com.inq.flash.client.chatskins.BalloonNotifier'] = com.inq.flash.client.chatskins.BalloonNotifier;
/** @private @type {Array} */
com.inq.flash.client.chatskins.BalloonNotifier.__name__ = ["com","inq","flash","client","chatskins","BalloonNotifier"];

/**
 * Clear
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function Clear()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.BalloonNotifier.Clear = function() {
	/** @type {Array} */
	var elements = null;
	try {
		elements = Application.application._div.getElementsByTagName("*");
		if(elements == null) return;
	} catch( unknown ) {
		return;
	}
	for (var i = 0, len = elements.length; i < len; i++) {
		try {
			var el = elements[i];
			if (el["balloon"] != null) {
				el.balloon.destroy();
				el.balloon = null;
			} else if (el.className.indexOf(com.inq.flash.client.chatskins.BalloonNotifier.BALLOON_CLASSNAME) >= 0) {
				if (el.parentNode) {
					el.parentNode.removeChild(el);
				}
			}
		} catch( unknown ) {
			haxe.Log.trace("Clear failed" + Std.string(unknown),{ fileName : "BalloonNotifier.hx", lineNumber : 35, className : "com.inq.flash.client.chatskins.BalloonNotifier", methodName : "Clear"});
		}
	}
};


/**
 * Resize
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function Resize()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.BalloonNotifier.Resize = function() {
	/** @type {Array} */
	var elements = null;
	try {
		elements = Application.application._div.getElementsByTagName("*");
		if(elements == null) return;
	} catch( unknown ) {
		return;
	}
	for (var i = 0, len = elements.length; i < len; i++) {
		try {
			var el = elements[i];
			if (el["balloon"] != null) {
				el.balloon.resize();
			}
		} catch( unknown ) {
			haxe.Log.trace("Resize failed" + Std.string(unknown),{ fileName : "BalloonNotifier.hx", lineNumber : 58, className : "com.inq.flash.client.chatskins.BalloonNotifier", methodName : "Resize"});
		}
	}
};


/**
 * Notify
 *
 * $type TFun([{ name => element, t => TDynamic(null), opt => false },{ name => text, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function Notify(element:Dynamic, text:String)
 * @public
 * @static
 * @param {null}  element 
 * @param {string}  text 
 * @return {void}
 */
com.inq.flash.client.chatskins.BalloonNotifier.Notify = function(element,text) {
	com.inq.flash.client.chatskins.BalloonNotifier.show(element,text,"BalloonNotify");
};


/**
 * Warn
 *
 * $type TFun([{ name => element, t => TDynamic(null), opt => false },{ name => text, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function Warn(element:Dynamic, text:String)
 * @public
 * @static
 * @param {null}  element 
 * @param {string}  text 
 * @return {void}
 */
com.inq.flash.client.chatskins.BalloonNotifier.Warn = function(element,text) {
	com.inq.flash.client.chatskins.BalloonNotifier.show(element,text,"BalloonWarn");
	element.onfocus = function(ev) {
		element.balloon.destroy();
	};
};


/**
 * show
 *
 * $type TFun([{ name => element, t => TDynamic(null), opt => false },{ name => text, t => TInst(String,[]), opt => false },{ name => styleName, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * private static function show(element:Dynamic, text:String, styleName:String)
 * @private
 * @static
 * @param {null}  element 
 * @param {string}  text 
 * @param {string}  styleName 
 * @return {void}
 */
com.inq.flash.client.chatskins.BalloonNotifier.show = function(element,text,styleName) {
	/** @type {Element} */
	var c = window.document.getElementById("chatWindow_span").parentNode;
	if(c != null || c.length > 0) {
		element.balloon = new com.inq.ui.BalloonOverlaying(Std.string(element.id) + "_balloon",styleName,element,text,c);
		element.balloon._div.className += " " + com.inq.flash.client.chatskins.BalloonNotifier.BALLOON_CLASSNAME;
		element.balloon.addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.BalloonNotifier.onBalloonClick);
	}
};


/**
 * onBalloonClick
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function onBalloonClick(me:MouseEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.MouseEvent}  me 
 * @return {boolean}
 */
com.inq.flash.client.chatskins.BalloonNotifier.onBalloonClick = function(me) {
	try {
		/** @type {com.inq.ui.BalloonOverlaying} */
		var target = me.currentTarget;
		/** @type {Element} */
		var el = null;
		el = target.destroy();
		if(el != null) {
			if(el != null && el.focus != null) el.focus();
		}
	} catch( unknown ) {
		haxe.Log.trace("onBalloonClick" + Std.string(unknown),{ fileName : "BalloonNotifier.hx", lineNumber : 90, className : "com.inq.flash.client.chatskins.BalloonNotifier", methodName : "onBalloonClick"});
	}
	return true;
};

/** @type {com.inq.flash.client.chatskins.BalloonNotifier} */
com.inq.flash.client.chatskins.BalloonNotifier.prototype.__class__ = com.inq.flash.client.chatskins.BalloonNotifier;

/** @public @type {string} */
com.inq.flash.client.chatskins.BalloonNotifier.BALLOON_CLASSNAME = "balloon-notifier";
